import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild } from "@angular/router";
import { Store } from "@ngrx/store";
import {
	AuthSelector,
	CORE_ROUTE,
	CoreState,
	ResponsibleGamingConfigService,
	SportsbookBlockSelector,
} from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
	providedIn: "root",
})
export class CasinoBlockGuard implements CanActivateChild, CanActivate {
	constructor(
		private store: Store<CoreState>,
		private rgConfig: ResponsibleGamingConfigService
	) {}

	canActivate(): Observable<boolean> {
		return combineLatest([
			this.store.select(AuthSelector.isAuthenticated),
			this.store.select(SportsbookBlockSelector.shouldChoosePlayerProfile),
		]).pipe(
			map(([isAuthenticated, shouldChoose]) => {
				if (this.rgConfig.getCasinoBlockEnabled() && isAuthenticated && shouldChoose) {
					this.store.dispatch(RouteAction.navigate(CORE_ROUTE.responsibleGaming.selectPlayerProfile));
				}
				return true;
			})
		);
	}

	canActivateChild(): Observable<boolean> {
		return this.canActivate();
	}
}
